module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("3VFGW"))).then(() => parcelRequire('d0iPb'));